const teccom = {
  order_suffix: 'Order suffix',
  order_suffix_placeholder: 'Suffix',
  delivery_config: 'Delivery configuration',
  documents: {
    // Filters
    document_id: 'Document number',
    seller_party_number: 'TecCom supplier',
    seller_party_number_hint:
      'Supplier number as printed on the document: pick one from the list or type it and press Enter',
    date_from: 'From',
    date_to: 'To',

    // Columns / header fields
    columns: {
      document_id: 'Document no.',
      issue_date: 'Document date',
      delivery_date: 'Delivery date',
      dispatch_date: 'Dispatch date',
      order_date: 'Order date',
      seller_name: 'Supplier',
      delivery_name: 'Delivered to',
      seller_order_number: 'Supplier order',
      buyer_order_number: 'CATI order',
      transport_means: 'Carrier',
      message_status: 'Message status',
      source_version: 'Document version',
      versions_count: 'Versions',
      received_at: 'Received at',
      ftp_written_at: 'Written to FTP at',
      account_id: 'TecCom account',
      actions: 'Actions',
    },

    // Row actions
    details: 'Header detail',
    view: 'View XML',
    download: 'Download XML',
    formats: {
      pretty: 'Readable XML',
      raw: 'Original XML',
      desadv_20: 'DesAdv 2.0',
      desadv_50: 'DesAdv 5.0',
    },

    // Detail
    detail_title: 'Document header {document}',
    header: 'Header',
    parties: 'Parties',
    party: {
      seller: 'Supplier (seller)',
      buyer: 'Customer (buyer)',
      delivery: 'Delivered to',
      invoice: 'Invoice recipient',
    },
    transport: 'Transport',
    transport_mode: 'Transport mode',
    transport_type_code: 'Transport type',
    free_text: 'Notes',
    storage: 'Storage',
    content_hash: 'Content hash',
    response_sequence: 'Sequence in response',
    ftp_filename: 'FTP file',
    ftp_path: 'FTP path',
    created_at: 'Created at',
    updated_at: 'Updated at',

    versions_hint:
      '{count} versions of this document were received; the latest one is shown here',
  },
}

export default teccom
